import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-addition-reduction-warning',
  standalone: true,
  imports: [CommonModule,DataTablesModule, FormsModule],
  templateUrl: './addition-reduction-warning.component.html',
  styleUrl: './addition-reduction-warning.component.scss'
})
export class AdditionReductionWarningComponent {
  isDisabled: boolean = false;
  @Input() Message: string = '';
  @Input() Dataa : any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  dtoptions: DataTables.Settings = {};
  constructor(
    private activeModal: NgbActiveModal,
    protected common: CommonService
  ) {
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() : void{}
  
  close(result:boolean) {
    this.activeModal.close(result);
  }
}
